import { useEffect, useRef } from 'react';
import { X } from 'lucide-react';
import '../../ManageBotsModal/ManageBotsModal.css';
import './FormModal.css';

/**
 * FormModal — chrome de modal (overlay + painel) para os forms de
 * criar/editar Downsell, Upsell e Disparo. Extraído pra esses três pararem
 * de substituir a lista inteira (tela cheia) e virarem um modal que sobrepõe
 * a lista, sem ocupar 100% da largura no desktop.
 *
 * Reaproveita as classes `manage-bots-modal-overlay`/`manage-bots-modal` já
 * usadas nos outros modais do app (mesmo fundo/blur) — só adiciona o
 * necessário pra caber um form longo (scroll interno, largura maior).
 */
export default function FormModal({ open, onClose, maxWidth = 880, children }) {
    // Selecionar texto dentro do form (ex.: arrastar pra selecionar num
    // textarea) e soltar o botão fora do painel dispara um "click" sintético
    // no overlay — mousedown e mouseup em elementos diferentes viram um único
    // click no ancestral comum. Só fecha se o mousedown E o click tiverem
    // começado/terminado no overlay em si (não um "pseudo clique" de drag).
    const mouseDownOnOverlay = useRef(false);

    useEffect(() => {
        if (!open) return;
        const onKeyDown = (e) => {
            if (e.key === 'Escape') onClose?.();
        };
        document.addEventListener('keydown', onKeyDown);
        const prevOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        return () => {
            document.removeEventListener('keydown', onKeyDown);
            document.body.style.overflow = prevOverflow;
        };
    }, [open, onClose]);

    if (!open) return null;

    return (
        <div
            className="manage-bots-modal-overlay"
            onMouseDown={(e) => {
                mouseDownOnOverlay.current = e.target === e.currentTarget;
            }}
            onClick={(e) => {
                if (mouseDownOnOverlay.current && e.target === e.currentTarget) {
                    onClose?.();
                }
            }}
        >
            <div
                className="manage-bots-modal form-modal-panel"
                style={{ maxWidth }}
                onClick={(e) => e.stopPropagation()}
            >
                <button type="button" className="manage-bots-close form-modal-close" onClick={onClose} aria-label="Fechar">
                    <X size={18} />
                </button>
                {children}
            </div>
        </div>
    );
}
